import { render } from "./ProjectController.vue?vue&type=template&id=1c50efc9"
import script from "./ProjectController.vue?vue&type=script&lang=js"
export * from "./ProjectController.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__